import { EditorPlatformContextEnvironment } from '@wix/editor-platform-environment-api';

new EditorPlatformContextEnvironment().expose();
